'use client';
import styled, { css } from 'styled-components';

export const Message = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(14)};

  ${props =>
    props.variant !== 'control' &&
    css`
      display: flex;
      text-align: left;

      @media ${props => props.theme.mobileM} {
        margin: ${({ theme }) => theme.spacing(0, 1, 14, 5)};
      }
      @media ${props => props.theme.mobileL} {
        margin: ${({ theme }) => theme.spacing(0, 1, 14, 1)};
      }
    `}
`;

export const Headline = styled.h2`
  ${props =>
    props.variant === 'control'
      ? props.theme.typography.subheading1
      : props.theme.typography.heading6}
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  ${props =>
    props.variant !== 'control' &&
    css`
      width: 100%;
      @media ${props => props.theme.mobileM} {
        max-width: 230px;
      }
      @media ${props => props.theme.mobileL} {
        max-width: 100%;
      }
    `}
`;

export const Text = styled.p`
  ${props =>
    props.variant === 'control'
      ? props.theme.typography.heading3
      : props.theme.typography.body}
`;

export const PlanLoaderImage = styled.div`
  height: ${props => props.theme.spacing(18)};
  width: ${props => props.theme.spacing(18)};
  display: inline-flex;
  margin-right: ${props => props.theme.spacing(3)};
  max-width: 64px;
  max-height: 64px;

  img {
    border-radius: 50%;
    text-align: center;
    min-height: 64px;
    min-width: 64px;
  }
`;

export const PlanLoaderContent = styled.div`
  width: 100%;
  ${props =>
    props.variant !== 'control' &&
    css`
      width: 75%;

      @media ${props => props.theme.mobileL} {
        width: 85%;
      }
    `}
`;
